<app-loading></app-loading>
<router-outlet *ngIf="!(loading$ | async)"></router-outlet>
